module.exports = __webpack_public_path__ + "static/img/z07.4d8faa2a.png";